import { Directive, TemplateRef } from '@angular/core'

@Directive({
	selector: '[uiCommonAccordionContent]',
})
export class AccordionContentDirective {
	constructor(public templateRef: TemplateRef<unknown>) {}
}
